// extracted by mini-css-extract-plugin
module.exports = {"circle_button":"circle_button__SdQRO2BYC1Use","shadow":"shadow__-THtkPkBRswOy","points_wrapper":"points_wrapper__8PrhoZfef1VL7","point":"point__eGZtWjBkNPpri"};